import React, { useState, useEffect } from 'react';




import { getMySubjects, addAnnouncement, getTeacherAnnouncements } from '../../api';
import { toast } from 'react-toastify';

const Announcements = () => {
  const [subjects, setSubjects] = useState([]);
  const [announcements, setAnnouncements] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    title: '', content: '', type: 'general',
    subject_id: '', class_id: ''
  });

  useEffect(() => { loadData(); }, []);

  const loadData = async () => {
    try {
      const [s, a] = await Promise.all([getMySubjects(), getTeacherAnnouncements()]);
      setSubjects(s.data);
      setAnnouncements(a.data);
    } catch (err) {
      toast.error('Error loading data');
    }
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    try {
      const selectedSubject = subjects.find(s => s.id === parseInt(formData.subject_id));
      await addAnnouncement({
        ...formData,
        class_id: selectedSubject?.class_id || null
      });
      toast.success('Announcement added!');
      setShowForm(false);
      setFormData({ title: '', content: '', type: 'general', subject_id: '', class_id: '' });
      loadData();
    } catch (err) {
      toast.error('Error adding announcement');
    }
  };

  const typeColors = {
    test: { bg: '#f8d7da', color: '#721c24' },
    syllabus: { bg: '#cce5ff', color: '#004085' },
    assignment: { bg: '#fff3cd', color: '#856404' },
    general: { bg: '#d4edda', color: '#155724' },
  };

  return (
    <div>
      <div style={styles.header}>
        <h3 style={styles.title}>📢 Announcements</h3>
        <button style={styles.addBtn} onClick={() => setShowForm(!showForm)}>
          + Add Announcement
        </button>
      </div>

      {showForm && (
        <div style={styles.formCard}>
          <h4 style={styles.formTitle}>New Announcement</h4>
          <form onSubmit={handleAdd}>
            <div style={styles.formGrid}>
              <div>
                <label style={styles.label}>Title</label>
                <input style={styles.input} placeholder="Announcement title"
                  value={formData.title}
                  onChange={e => setFormData({...formData, title: e.target.value})} required />
              </div>
              <div>
                <label style={styles.label}>Type</label>
                <select style={styles.input} value={formData.type}
                  onChange={e => setFormData({...formData, type: e.target.value})}>
                  <option value="general">General</option>
                  <option value="test">Test</option>
                  <option value="syllabus">Syllabus</option>
                  <option value="assignment">Assignment</option>
                </select>
              </div>
              <div>
                <label style={styles.label}>Subject</label>
                <select style={styles.input} value={formData.subject_id}
                  onChange={e => setFormData({...formData, subject_id: e.target.value})}>
                  <option value="">Select Subject</option>
                  {subjects.map(s => (
                    <option key={s.id} value={s.id}>{s.name} - {s.class_name}</option>
                  ))}
                </select>
              </div>
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Content</label>
              <textarea style={styles.textarea} placeholder="Announcement details..."
                value={formData.content} rows={4}
                onChange={e => setFormData({...formData, content: e.target.value})} required />
            </div>
            <div style={styles.btnGroup}>
              <button type="submit" style={styles.addBtn}>Post</button>
              <button type="button" style={styles.cancelBtn}
                onClick={() => setShowForm(false)}>Cancel</button>
            </div>
          </form>
        </div>
      )}

      <div style={styles.list}>
        {announcements.length === 0 && (
          <div style={styles.empty}>No announcements yet!</div>
        )}
        {announcements.map(a => (
          <div key={a.id} style={styles.announcementCard}>
            <div style={styles.cardHeader}>
              <h4 style={styles.announcementTitle}>{a.title}</h4>
              <span style={{
                ...styles.typeBadge,
                background: typeColors[a.type]?.bg,
                color: typeColors[a.type]?.color
              }}>
                {a.type}
              </span>
            </div>
            <p style={styles.content}>{a.content}</p>
            <p style={styles.date}>
              {new Date(a.created_at).toLocaleDateString()}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
  title: { color: '#1a6b3a', margin: 0 },
  addBtn: { padding: '10px 20px', background: '#28a745', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' },
  cancelBtn: { padding: '10px 20px', background: '#6c757d', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' },
  formCard: { background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' },
  formTitle: { color: '#1a6b3a', margin: '0 0 15px' },
  formGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '15px', marginBottom: '15px' },
  inputGroup: { marginBottom: '15px' },
  label: { fontSize: '13px', fontWeight: '600', color: '#555', display: 'block', marginBottom: '5px' },
  input: { padding: '10px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px', width: '100%' },
  textarea: { padding: '10px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px', width: '100%', resize: 'vertical' },
  btnGroup: { display: 'flex', gap: '10px' },
  list: { display: 'flex', flexDirection: 'column', gap: '15px' },
  empty: { textAlign: 'center', color: '#999', padding: '40px', background: 'white', borderRadius: '12px' },
  announcementCard: { background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)', borderLeft: '4px solid #28a745' },
  cardHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' },
  announcementTitle: { color: '#1a6b3a', margin: 0, fontSize: '16px' },
  typeBadge: { padding: '4px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '600' },
  content: { color: '#555', fontSize: '14px', lineHeight: '1.6', margin: '0 0 10px' },
  date: { color: '#999', fontSize: '12px', margin: 0 },
};

export default Announcements;